<div class="row login-wrapper no-gutters position-relative border-bottom">
    <img class="login-img" src="https://equityisdynamic-static.s3.amazonaws.com/misc/login.png">
    <div class="subtitle text-uppercase py-3 px-3 d-lg-none position-absolute">Equity is <i>Dynamic</i></div>
    <div class="col-12 col-lg-6">
        <div class="subtitle text-uppercase py-3 px-3 d-none d-lg-block">Equity is <i>Dynamic</i></div>
        <div class="py-5 px-3">
            <h1>sign in </h1>
        </div>
        <form autocomplete="off" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="border-top">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col-12 col-lg-10 subtitle">Email Address</div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12">
                            <input type="text" autocapitalize="off" autocorrect="off" formControlName="username" class="form-control text-xlarge"
                                [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autocomplete="Off"
                                placeholder="me@email.com" />
                            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                                <div *ngIf="f.username.errors.required">Username is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border-top border-bottom">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col-12 col-lg-10 subtitle">Password</div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12">
                            <input type="password" formControlName="password" class="form-control text-xlarge"
                                autocomplete="off" [ngClass]="{ 'is-invalid text-red': submitted && f.password.errors }"
                                placeholder="Password" />
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">Password is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col-12 col-lg-10"><a href="/forgot-password">I forgot my password</a></div>
                        <div class="col-12 col-lg-7 pt-4">
                            By signing in, you are agreeing to our <a href="https://www.equityisdynamic.com/terms-of-service" target="_blank">Terms of Service</a> and <a
                                href="https://www.equityisdynamic.com/privacy-policy" target="_blank">Privacy Policy</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col">
                            <button [disabled]="loading" class="btn btn-primary px-5">
                                Sign In
                            </button>
                            <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>